import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0b41686b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=0b41686b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b41686b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b41686b')) {
      api.createRecord('0b41686b', component.options)
    } else {
      api.reload('0b41686b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0b41686b&scoped=true&", function () {
      api.rerender('0b41686b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/successpage/index.vue"
export default component.exports